<div class="popup marginBottomStyle" 
    style="position: relative;  height: 100%;overflow: hidden;">

    <div class="row topRowMargins headerStyle" style="margin-top: 0;">
      <div  style="margin-left: 15px;">
        <label class="textColour">{{titleText}}</label>
      </div>
    </div>
    <div class="container" style="margin: 0;padding: 0;" >
        <form novalidate [formGroup]='validations_form'>
             <div class="row">
                
                 <div class="col-lg-4">
                <mat-form-field class="filter" appearance="outline">
                    <mat-label i18n="@@targetloginusername">
                        Activity Type
                    </mat-label>
                    <mat-select formControlName="activityType" [(ngModel)]="activityType" >
                            <mat-option *ngFor="let tempObject of activityTypeList" [value]="tempObject.lookupvalue">
                                {{tempObject.lookupcode}}
                            </mat-option>

                    </mat-select>
                    <mat-error *ngFor="let validation of validation_messages.activityType">
                      <span
                        *ngIf="validations_form.get('activityType').hasError(validation.type) && (validations_form.get('activityType').dirty || validations_form.get('activityType').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
               <div class="col-lg-4">
                     <mat-form-field class="filter" appearance="outline">
                    <mat-label i18n="@@TMSTAFFMASTERfirstname">Activity Name</mat-label>
                    <input matInput type="text" placeholder="Activity Name" formControlName="activityName"
                      [(ngModel)]="activityName" maxlength="100" required >
                        <mat-error *ngFor="let validation of validation_messages.activityName">
                        <span
                            *ngIf="validations_form.get('activityName').hasError(validation.type) && (validations_form.get('activityName').dirty || validations_form.get('activityName').touched)">
                            {{ validation.message }}
                        </span>
                        </mat-error>
                    </mat-form-field>
                 </div>

                   <!-- DATASET -->
            <div class="col-lg-4">
                <mat-form-field appearance="outline" class="filter">
                <mat-label>Select Dataset</mat-label>
                <mat-select formControlName="dataset" [(ngModel)]="selectedDataset" (selectionChange)="onDatasetChange()">
                    <mat-option *ngFor="let ds of datasets" [value]="ds">
                    {{ ds.datasetname }}
                    </mat-option>
                </mat-select>
                <mat-error *ngFor="let validation of validation_messages.dataset">
                      <span
                        *ngIf="validations_form.get('dataset').hasError(validation.type) && (validations_form.get('dataset').dirty || validations_form.get('dataset').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
            </div>
             </div>
             <div class="row">
                <!-- VISUAL -->
                <div class="col-lg-4">
                    <mat-form-field appearance="outline" class="filter">
                    <mat-label>Select Visual</mat-label>
                    <mat-select formControlName="visual" [(ngModel)]="selectedVisual">
                          <mat-option *ngIf="visualData?.length === 0" disabled>
                        No visuals available
                    </mat-option>
                        <mat-option *ngFor="let v of visualData" [value]="v">
                        {{ v.visualName }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngFor="let validation of validation_messages.visual">
                      <span
                        *ngIf="validations_form.get('visual').hasError(validation.type) && (validations_form.get('visual').dirty || validations_form.get('visual').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                    </mat-form-field>
                </div>

                <!-- REPORT TEMPLATE -->
                <div class="col-lg-4">
                    <mat-form-field appearance="outline" class="filter">
                    <mat-label>Select Report Template</mat-label>
                    <mat-select formControlName="reportTemplate" [(ngModel)]="selectedTemplate" (selectionChange)="onReportSelected()">
                        <mat-option *ngFor="let r of AllReportTemplates" [value]="r">
                        {{ r.reportTemplateName }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngFor="let validation of validation_messages.reportTemplate">
                      <span
                        *ngIf="validations_form.get('reportTemplate').hasError(validation.type) && (validations_form.get('reportTemplate').dirty || validations_form.get('reportTemplate').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                    </mat-form-field>
                </div>

                </div>
        </form>
    </div>
    <div  class="row mb-1 topRowMargins" style="position: absolute;
    width: 100%;
    bottom: 0;" >

        <div class="col-lg text-center" >

            <div style="text-align: end">
                     <app-common-button
                        label={{buttonName}} title={{buttonName}}
                        [buttonId]="1111"
                        padding="0rem 1rem"
                        fontSize=".85rem"
                        height="25px"
                        (clicked)="onCreate()"
                        style="margin-right:1%"
                        > 
                    </app-common-button>

                    <app-common-button
                         label="Cancel" title="Cancel"
                        [buttonId]="1111"
                        [variant]="'cancel'"
                        padding="0rem 1rem"
                        fontSize=".85rem"
                        height="25px"
                        (clicked)="onCancel()"
                        style="margin-right:1%"
                        > 
                    </app-common-button>


            </div>
 
        </div>
        
    </div>
    </div>